export const RenderType = {
    Column: 0,
    Row: 1,
} as const;

export const HeaderType = {
    Box: 0,
    Centered: 1,
    Big: 2,
    Serif: 3,
} as const;


export const RedesignHeaderType = {
    Big: 0,
    Small: 1,
} as const;